import { Game } from "../types/game";

export const PAY_BEFORE_PLAY_ORGANISER_ONLY_JOIN_MSG =
  "This game requires the organiser to add you. Please contact the organiser.";

export function isPayBeforePlayPaidGame(game: Pick<Game, "isPaid" | "paymentRules">): boolean {
  return !!(game.isPaid && game.paymentRules?.payBeforePlay);
}

/** Player must pay via Stripe Checkout before joining (organisers use roster add). */
export function shouldUsePayBeforeJoinCheckout(
  game: Pick<Game, "isPaid" | "paymentRules">,
  canManagePayments: boolean,
): boolean {
  return isPayBeforePlayPaidGame(game) && !canManagePayments;
}
